import React, { useEffect, useState, useContext } from "react";
import DropZone from "core/ui/drop-zone";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import ConfirmDelete from "core/ui/confirm-delete";
import SessionContext from "SessionContext";

export default function DualSelect({
  name,
  allOptions,
  selectedOptions,
  setSelectedOptions,
  disabled,
  optionLabel = "name",
  displayTemplates = false,
  onChangeTemplate,
  showSelectionOnly = false,
  availableOptionsRender = (o) => <>{o[optionLabel]}</>,
  selectedOptionsRender = (o) => <>{o[optionLabel]}</>,
}) {
  const session = useContext(SessionContext);

  const [searchTerm, setSearchTerm] = useState("");
  const [availableOptions, setAvailableOptions] = useState(allOptions);
  const [population, setPopulation] = useState();

  useEffect(() => {
    const regex = new RegExp(`${searchTerm}`, "i");
    setAvailableOptions(
      allOptions
        .filter((f) => regex.test(f[optionLabel]))
        .filter((f) => !selectedOptions.find((t) => t.id === f.id))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, selectedOptions, allOptions]);

  function onOptionDragStart(ev, field) {
    ev.dataTransfer.setData(name, JSON.stringify(field));
  }

  function onOptionDrop(ev) {
    const rawData = ev.dataTransfer.getData(name);
    if (rawData) {
      const droppedOption = JSON.parse(rawData);
      setSelectedOptions((prevValue) => {
        return [...prevValue, droppedOption];
      });
    }
  }

  function onSelectTemplate(options) {
    onChangeTemplate([]);
    if(options.length) {
      onChangeTemplate(options);
    }
  }

  function onOptionDragEnd(ev) {}

  function onClickRemoveOption(id) {
    setSelectedOptions((prevValue) => prevValue.filter((f) => f.id !== id));
  }

  useEffect(() => {
    if(session) {
      setPopulation(session.crossfilterStore.explorerModule);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session])

  if(showSelectionOnly) {
    return (
      <>
      <section className="dual-select-section disabled">
        <div className="additional-data">
          <div className="other-search">
            <h3>{name}</h3>
          </div>
          <div className="form-group dual-select">
          <div id="select-items" className="panel left">
            {availableOptions.map((f) => (
              <div
                key={f.id}
                className="ds-item"
                draggable={false}
              >
                {availableOptionsRender(f)}
              </div>
            ))}
          </div>
          <div id="deselect-items" className="panel right">
            {selectedOptions && selectedOptions.length > 0 && (
              <DropZone onDrop={onOptionDrop}>
                <div className="drop-target">
                {selectedOptions.map((f) => (
                  <div key={f.id} className="ds-item deselect">
                    {selectedOptionsRender(f)}
                  </div>
                ))} 
                </div>
              </DropZone>
            )}
          </div>
        </div>
        </div>
      </section>
      </>
    )
  }

  return (
    <section className="dual-select-section">
      <div className="additional-data">
          <div className="other-header">
              <>
              <div className="other-search">
                {name && <h3>{name}</h3>}
                <input
                  type="text"
                  placeholder="search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <i className="fa-solid fa-magnifying-glass field-search" />
              </div>
              <div className="other-sort">
                <i className="fa-solid fa-sort-alt" />
              </div>
              </>
            {
              displayTemplates && !disabled && population !== "consumers" && (
                <div className="layout-dropdown">
                  <h3>Output Layout Templates</h3>
                  <div>
                    <SelectLayout 
                      onSelect={onSelectTemplate} 
                      onRemove={onClickRemoveOption}
                      availableOptions={allOptions}
                      selectedOptions={selectedOptions}
                      population={population}
                    />
                  </div>
                </div>
              )
            }
          </div>
          
          <div className="form-group dual-select">
            <div id="select-items" className="panel left">
              {availableOptions.map((f) => (
                <div
                  key={f.id}
                  className="ds-item"
                  draggable={!disabled}
                  onDragStart={(e) => onOptionDragStart(e, f)}
                  onDragEnd={onOptionDragEnd}
                >
                  {availableOptionsRender(f)}
                </div>
              ))}
            </div>
            <div id="deselect-items" className="panel right">
              {selectedOptions && selectedOptions.length > 0 ? (
                <>
                  <DropZone onDrop={onOptionDrop}>
                  <div className="drop-target">
                  {selectedOptions.map((f) => (
                    <div key={f.id} className="ds-item deselect">
                      {selectedOptionsRender(f)}
                      <i className="fa-solid fa-grip-vertical grip-field"></i>
                      {!disabled &&
                        <i
                          className="fa-solid fa-xmark remove-field"
                          onClick={() => onClickRemoveOption(f.id)}
                        />
                      }
                    </div>
                  ))} </div></DropZone>
                  {!disabled &&
                    <DropZone onDrop={onOptionDrop}>
                      <div className="ds-item placeholder drop-target">
                        Drop field here
                      </div>
                    </DropZone>
                  }
                </>
              ) : (
                !disabled &&
                <DropZone onDrop={onOptionDrop}>
                  <div className="empty drop-target">
                    <i className="fa-solid fa-circle-plus"></i>
                    <p>Drag and drop additional items here</p>
                  </div>
              </DropZone>
              )}
            </div>
          </div>
        </div>
    </section>
  );
}


const SelectLayout = ({onSelect, availableOptions, population, selectedOptions}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selection, setSelection] = useState();
  const [showModalClear, setShowModalClear] = useState(false);
  const [tempId, setTempId] = useState(99);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const confirmedClear = () => {
    let _options = getOptions(population);
    setSelection(_options[tempId]);
    setShowModalClear(false);
  }
  
  const handleSelectionChange = (id) => {
    setTempId(id);
  };

  useEffect(() => {
    function updateSelections() {
      if(tempId === 0) {
        onSelect([]);
        let _options = getOptions(population);
        setSelection(_options[tempId]);
      } else {
        if(selectedOptions.length) {
          setShowModalClear(true);
        } else {
          confirmedClear();
        }
      }
    }
    
    if(tempId !== 99) {
      updateSelections();
    }
    // eslint-disable-next-line
  }, [tempId])

  useEffect(() => {
    if(population === "consumers") {
      return;
    }

    if(selection) {
      addNewTemplate();
    } else {
      setSelection(optionsInit);
    }
    // eslint-disable-next-line
  }, [selection, population])

  useEffect(() => {
    setSelection(optionsInit);
  }, [])

  const addNewTemplate = () => {
    if(selection.codes && selection.codes.length) {
      let temp = [];
      selection.codes.forEach((code) => {
        availableOptions.forEach((option) => {
          if(option.id === code) {
            temp.push(code);
          }
        });
      })
      if(temp.length) {
        onSelect(temp);
      }
    }
  };

  const cancelTemplateChangeModal = () => {
    setShowModalClear(false);
    setTempId(99);
  }

  return (<>
    <Dropdown isOpen={isOpen} toggle={handleToggle}>
      <DropdownToggle size="sm" caret color="light">
        {selection && selection.label}
      </DropdownToggle>
      <DropdownMenu>
        {getOptions(population).map((option) => (
          <DropdownItem
            key={option.label}
            value={option.id}
            onClick={() => handleSelectionChange(option.id)}
          >
            {option.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
    <ConfirmDelete
      show={showModalClear}
      label="Applying template will replace existing output fields"
      proceed={confirmedClear}
      cancel={cancelTemplateChangeModal}
      actionBtnLabel="Proceed"
    />
  </>);
}

/**
 * hardcoded template fields
 */
const optionsInit = {
  id: 99,
  label: "Select a Layout Template",
  codes: []
}
const moversOptions = [
  {
    id: 0,
    label: "None",
    codes: ["none"]
  },
  {
   id: 1,
   label: "Premover at List",
   codes: ["premoversatlist_trigger_date"]
  },
  {
    id: 2,
    label: "Premover at Contract",
    codes: ["premoversatcontract_trigger_date"]
  },
  {
    id: 3,
    label: "New Movers",
    codes: ["newmovers_trigger_date"]
  },
  {
    id: 4,
    label: "New Movers with Previous Address",
    codes: ["prev_addr1", "prev_city", "prev_state", "prev_zip", "prev_zip4", "newmovers_trigger_date"]
  }
];

const lifeEventsOptions = [
  {
    id: 0,
    label: "None",
    codes: ["none"]
  },
  {
    id: 1,
    label: "Newly Engaged",
    codes: ["newlyengaged_event_date", "newlyengaged_trigger_date"]
  },
  {
    id: 2,
    label: "Newly Married",
    codes: ["newlymarried_event_date", "newlymarried_trigger_date"]
  },
  {
    id: 3,
    label: "Prenatal",
    codes: ["prenatal_event_date", "prenatal_trigger_date"]
  },
  {
    id: 4,
    label: "New Baby",
    codes: ["newbaby_event_date", "newbaby_trigger_date"]
  },
  {
    id: 5,
    label: "Newly Single",
    codes: ["newlysingle_event_date", "newlysingle_trigger_date"]
  }
];

const getOptions = (_population) => {
  if(_population === "movers") {
    return moversOptions;
  } else if(_population === "life_events") {
    return lifeEventsOptions;
  } else {
    return [];
  }
}
